var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonSecondary',{attrs:{"data-test-id":"HeaderItemPricing__pricingButton","text":_vm.pricingButtonText},on:{"click":_vm.openPricingPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }